import { useEffect, useRef, useState } from 'react';

export function usePullToRefresh(onRefresh, enabled = true) {
  const [isPulling, setIsPulling] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const touchStartY = useRef(0);
  const isRefreshing = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    let rafId = null;

    const handleTouchStart = (e) => {
      // Only trigger if at top of scroll
      if (window.scrollY > 5) return;
      touchStartY.current = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      if (isRefreshing.current || window.scrollY > 5) return;
      
      const touchY = e.touches[0].clientY;
      const diff = touchY - touchStartY.current;

      if (diff > 0 && diff < 150) {
        setIsPulling(true);
        setPullDistance(diff);
        
        // Prevent native pull-to-refresh
        if (diff > 10) {
          e.preventDefault();
        }
      }
    };

    const handleTouchEnd = async () => {
      if (pullDistance > 80 && !isRefreshing.current) {
        isRefreshing.current = true;
        setIsPulling(true);
        setPullDistance(80);
        
        try {
          await onRefresh();
        } finally {
          setTimeout(() => {
            setIsPulling(false);
            setPullDistance(0);
            isRefreshing.current = false;
          }, 300);
        }
      } else {
        setIsPulling(false);
        setPullDistance(0);
      }
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [enabled, onRefresh, pullDistance]);

  return { isPulling, pullDistance };
}